import React, { useEffect, useState } from "react";
import { useB2BContext } from "../../context/ContextB2B";
import overview from "../../data/state.json";
import { Button, Input, Select, Form } from "antd";
import { Option } from "antd/es/mentions";

function AddressPopup({ onFinishAddress }: any) {
  const { getUserByID } = useB2BContext();
  const [form] = Form.useForm();
  const [isValid, setIsValid] = useState(true);
  const [isValidGst, setIsValidGst] = useState(true);

  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  // Load from session storage on mount
  useEffect(() => {
    const storedValues = {
      address: sessionStorage.getItem("address") || "",
      city: sessionStorage.getItem("city") || "",
      country: sessionStorage.getItem("country") || "",
      state: sessionStorage.getItem("state") || undefined,
      state_code: sessionStorage.getItem("state_code") || "",
      pin_code: sessionStorage.getItem("pin_code") || "",
      company_pancard: sessionStorage.getItem("company_pancard") || "",
      gstin_number: sessionStorage.getItem("gstin_number") || "",
    };
    form.setFieldsValue(storedValues);
  }, [form]);

  // Save to session storage on blur
  const handleBlur = (e: any) => {
    const { name, value } = e.target;
    sessionStorage.setItem(name, value);
  };

  const handleChange = (e: any) => {
    const input = e.target.value.toUpperCase();
    setIsValid(input === "" || panRegex.test(input));
  };

  const handleChangeGst = (e: any) => {
    const input = e.target.value.toUpperCase();
    setIsValidGst(input === "" || gstRegex.test(input));
  };

  const handleSelectState = (value: string) => {
    sessionStorage.setItem("state", value);
  };

  return (
    <div className="add_form_wrapper address_form">
      <h3>Your Office address </h3>
      <Form
        name="normal_login"
        initialValues={{ remember: true }}
        onFinish={onFinishAddress}
        form={form}
      >
        {[
          {
            label: "Address",
            name: "address",
            placeholder: "Please enter your office address",
          },
          {
            label: "City",
            name: "city",
            placeholder: "Please enter where your office is located",
          },
          {
            label: "Country",
            name: "country",
            placeholder: "Please enter your office country",
          },
          {
            label: "State code",
            name: "state_code",
            placeholder: "Please enter your office State Code",
          },
          {
            label: "Pin Code",
            name: "pin_code",
            placeholder: "Please enter your office Pin Code",
          },
        ].map(({ label, name, placeholder }) => (
          <Form.Item
            key={name}
            label={label}
            name={name}
            rules={[
              { required: true, message: `Please enter your office ${label}` },
            ]}
            style={{ marginBottom: "16px" }}
          >
            <Input
              name={name}
              className="input"
              type="text"
              placeholder={placeholder}
              onBlur={handleBlur}
            />
          </Form.Item>
        ))}

        <Form.Item
          label="State"
          name="state"
          rules={[
            { required: true, message: "Please enter your office State" },
          ]}
          style={{ marginBottom: "16px" }}
        >
          <Select
            style={{ width: "100%", borderRadius: "8px" }}
            placeholder="Please Select The State"
            onChange={handleSelectState}
            value={form.getFieldValue("state")}
          >
            {overview?.map((item: any, index: any) => (
              <Option value={item.state} key={index}>
                {item.state}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Pan Card"
          name="company_pancard"
          rules={[
            { required: true, message: "Please enter your office Pan Number" },
          ]}
          style={{ marginBottom: "16px" }}
        >
          <Input
            name="company_pancard"
            className="input"
            type="text"
            placeholder="Please enter your office Pan Number"
            maxLength={10}
            onChange={(e) => {
              handleChange(e);
              handleBlur(e);
            }}
            onBlur={handleBlur}
          />
        </Form.Item>
        {!isValid && <p className="error">Invalid PAN format.</p>}

        <Form.Item
          label="GST"
          name="gstin_number"
          rules={[
            { required: true, message: "Please enter your office GST number" },
          ]}
          style={{ marginBottom: "16px" }}
        >
          <Input
            name="gstin_number"
            className="input"
            type="text"
            placeholder="Please enter your office GST number"
            maxLength={15}
            onChange={(e) => {
              handleChangeGst(e);
              handleBlur(e);
            }}
            onBlur={handleBlur}
          />
        </Form.Item>
        {!isValidGst && <p className="error">Invalid GST number format.</p>}

        <Button
          className="checkout_btn"
          htmlType="submit"
          style={{ marginTop: "24px" }}
        >
          Continue Checkout
        </Button>
      </Form>
    </div>
  );
}

export default AddressPopup;
